import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const feedbackCommentIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M58.667 5.818v37.818H27.619L16 52.67v-9.033H5.333V5.818h53.334zM64 0H0v49.4h10.667V64l18.666-14.6H64V0zM50.667 17.455H13.333v-2.91h37.334v2.91zm0 5.818H13.333v2.909h37.334v-2.91zm-16 8.727H13.333v2.91h21.334V32z"/></svg>`
);
